import { ITextValidator } from "../models/validator";

export class MaximumLengthValidator implements ITextValidator {
  private _maxLength: number = 0;

  constructor(length: number) {
    this._maxLength = length;
  }

  validate(value?: string): string | undefined {
    const msg = `Uw invoer is te lang, gebruik maximaal ${this._maxLength} tekens.`;
    const isEmpty = !value;

    if (isEmpty || value.length <= this._maxLength) return;

    return msg;
  }
}
